import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './HappyDonors.module.css';

const HappyDonors = () => {
  const donors = [
    {
      id: 1,
      img: "https://randomuser.me/api/portraits/men/32.jpg",
      text: "Z Foundation is a good and reliable charitable organization. It gives me confidence and satisfaction to know how these people utilize our donations in serving the poor people."
    },
    {
      id: 2,
      img: "https://randomuser.me/api/portraits/women/44.jpg",
      text: "It is of great satisfaction & humbling experience to work with Z Foundation members. Their commitment to support the needy & the poor is inspiring & they always step forward for the society - Great Work! Kudos for the team!!"
    },
    {
      id: 3,
      img: "https://randomuser.me/api/portraits/men/46.jpg",
      text: "They are connected with the marginal sections of the community and that's how they help them. I am very happy to be associated with them and have huge respect for the founder and the team members."
    }
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  // Smooth automation without layout shifts
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % donors.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [donors.length]);

  return (
    <motion.section
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 1 }}
      className={styles.donorSection}
    >
      {/* Decorative Corner Shapes */}
      <div className={styles.topCircle}></div>
      <div className={styles.bottomCircle}></div>

      <div className={styles.container}>
        <motion.h2
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className={styles.heading}
        >
          Happy Donors
        </motion.h2>

        {/* Testimonial Display Area */}
        <div className={styles.testimonialContainer}>
          <div className={styles.testimonialWrapper}>
            <span className={styles.quoteIcon}>“</span>
            <AnimatePresence mode="wait">
              <motion.div
                key={activeIndex}
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -15 }}
                transition={{ duration: 0.5 }}
                className={styles.contentWrapper}
              >
                <p className={styles.testimonialText}>
                  {donors[activeIndex].text}
                </p>
              </motion.div>
            </AnimatePresence>
            <span className={styles.quoteIcon}>”</span>
          </div>
        </div>

        {/* Dot Navigation */}
        <div className={styles.donorNav}>
          {donors.map((donor, index) => (
            <motion.div
              key={donor.id}
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.8 }}
              className={`${styles.dot} ${index === activeIndex ? styles.activeDot : ''}`}
              onClick={() => setActiveIndex(index)}
            />
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default HappyDonors;